// src/hooks/use-toast.ts
import React from 'react';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconX, IconInfoCircle, IconAlertCircle } from '@tabler/icons-react';

type ToastStatus = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  title: string;
  description?: string;
  status?: ToastStatus;
  duration?: number;
  id?: string;
}

const statusIcons: Record<ToastStatus, React.ReactNode> = {
  success: React.createElement(IconCheck, { size: 18 }),
  error: React.createElement(IconX, { size: 18 }),
  info: React.createElement(IconInfoCircle, { size: 18 }),
  warning: React.createElement(IconAlertCircle, { size: 18 }),
};

const statusColors: Record<ToastStatus, string> = {
  success: 'green',
  error: 'red',
  info: 'blue',
  warning: 'yellow',
};

export const toast = ({ 
  title, 
  description, 
  status = 'info',
  duration = 4000,
  id,
}: ToastProps) => {
  notifications.show({
    id,
    title,
    message: description,
    icon: statusIcons[status],
    color: statusColors[status],
    autoClose: duration,
  });
};

toast.close = (id: string) => {
  notifications.hide(id);
};

toast.closeAll = () => {
  notifications.clean();
};